const print = () => {
  const btnPrint = document.querySelector('#btn-print');

	if (btnPrint) {
		btnPrint.addEventListener('click', function (event) {
			window.print();

			return false;
		});
	}
};

export default print;